export const enum MarketingTopic {
  IqText = 'iq_text',
  LeftRight = 'left_right',
  Memory = 'dementia',
  BrainAge = 'brain_age',
  FocusType = 'focus_type',
  Personality = 'personality',
}

export const MARKETING_TOPIC_QUERY_PARAM = 'mt'

const MARKETING_TOPIC_BY_QUERY_VALUE: Record<string, MarketingTopic> = {
  [MarketingTopic.IqText]: MarketingTopic.IqText,
  [MarketingTopic.LeftRight]: MarketingTopic.LeftRight,
  [MarketingTopic.Memory]: MarketingTopic.Memory,
  [MarketingTopic.BrainAge]: MarketingTopic.BrainAge,
  [MarketingTopic.FocusType]: MarketingTopic.FocusType,
  [MarketingTopic.Personality]: MarketingTopic.Personality,
  lr: MarketingTopic.LeftRight,
  d: MarketingTopic.Memory,
  ba: MarketingTopic.BrainAge,
  ft: MarketingTopic.FocusType,
  p: MarketingTopic.Personality,
}

const getMarketingTopicRawFromSearch = (search: string): string | null => {
  const searchParams = new URLSearchParams(search)

  return searchParams.get(MARKETING_TOPIC_QUERY_PARAM)
}

export const getMarketingTopicFromRawValue = (
  rawTopic: string | null,
): MarketingTopic => {
  if (!rawTopic) {
    return MarketingTopic.IqText
  }

  return (
    MARKETING_TOPIC_BY_QUERY_VALUE[rawTopic.trim().toLowerCase()] ||
    MarketingTopic.IqText
  )
}

export const getMarketingTopicFromSearch = (search: string): MarketingTopic =>
  getMarketingTopicFromRawValue(getMarketingTopicRawFromSearch(search))

export const isAdaptiveMarketingTopic = (topic: MarketingTopic): boolean =>
  topic === MarketingTopic.LeftRight ||
  topic === MarketingTopic.Memory ||
  topic === MarketingTopic.BrainAge ||
  topic === MarketingTopic.FocusType ||
  topic === MarketingTopic.Personality

export const MARKETING_TOPIC_HERO_IMAGE_IDS = [
  'cohorts/intl_2/assets/images/offer/marketing-topics/left-right/hero.png',
  'cohorts/intl_2/assets/images/offer/marketing-topics/d/hero.png',
  'cohorts/intl_2/assets/images/offer/marketing-topics/brain-age/hero.png',
  'cohorts/intl_2/assets/images/offer/marketing-topics/focus-type/hero.png',
  'cohorts/intl_2/assets/images/offer/marketing-topics/personality/hero.png',
] as const
